var map = {
	"./Canvas.vue": 5096,
	"./DocumentIframe.js": 2892,
	"./Gallery.vue": 6652,
	"./ModeAndViewportToolbar.vue": 3207,
	"./ToolbarTop.vue": 8684,
	"./VersionActions.vue": 4142,
	"./tooltip.js": 3787
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8042;